import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import DtoSamplingSurfacePoint from '../../../../dto/DtoSamplingSurfacePoint'
import DtoSupport from '../../../../../referential/dto/DtoSupport'
import DtoKeyFigures from '../../../../../sites/dto/DtoKeyFigures'
import i18n from 'simple-react-i18n'
import { Avatar, Chip, List, ListItem } from '@material-ui/core'
import { find } from 'lodash'
import UUID from 'uuid'
import { nFormatter } from '../../../../../utils/NumberUtils'
import samplingPicture from '../../../../../../public/pictures/markers/map_sampling_point.png'
import { getDate } from '../../../../../utils/DateUtil'
import SamplingSurfacePointMapPanel from './SamplingSurfacePointMapPanel'

class SamplingSurfacePointPanel extends Component {
	constructor(props) {
		super(props)
	}

	createInformation = (title, value) => {
		return title + ' : ' + value
	}

	getLeftAvatar = () => {
		return (
			<Avatar src={ samplingPicture } style={ {
				width: 'auto',
				backgroundColor: 'none'
			} }
			/>
		)
	}

	getRightAvatar = (nbAnalysis) => {
		if (nbAnalysis) {
			return (
				<Avatar size={ 40 } style={ { fontSize: '10px !important' } }>
					{ nFormatter(nbAnalysis) }
				</Avatar>
			)
		}
		return (
			<Chip>
				{ i18n.noData }
			</Chip>
		)
	}

	getTitle = (sampling) => {
		const support = (() => {
			if (sampling.supportCode) {
				const supportRef = find(this.props.supports, (o) => {
					return o.id == sampling.supportCode
				})
				if (supportRef) {
					return ' - ' + supportRef.name + ' [' + sampling.supportCode + ']'
				}
				return ''
			}
			return ''
		})()

		if (sampling.code) {
			return this.createInformation(i18n.code, sampling.code) + ' ' + support
		}
		return support
	}
	getSecondaryText = (sampling, keyfigures) => {
		const keyFigureInformation = (() => {
			if (keyfigures) {
				const beginDate = getDate(keyfigures.beginDate)
				const endDate = getDate(keyfigures.endDate)
				const begin = (() => {
					if (beginDate) {
						return this.createInformation(i18n.firstDate, beginDate)
					}
					return ''
				})()
				const end = (() => {
					if (endDate) {
						return this.createInformation(i18n.lastDate, endDate)
					}
					return ''
				})()
				return begin + '  ' + end
			}
			return null
		})()
		if (sampling.status) {
			return this.createInformation(i18n.status, sampling.status) + '  ' + keyFigureInformation
		}
		return keyFigureInformation
	}

	getRow = (sampling) => {
		const keyfigures = find(this.props.pointKeyFigures, (o) => {
			return o.samplingId == sampling.id
		})
		const nbAnalysis = (() => {
			if (keyfigures) {
				return keyfigures.nbAnalysis
			}
			return 0
		})()
		return (
			<div key={ UUID.v4() } className={ 'col s12 no-padding' }>
				<ListItem key={ UUID.v4() } primaryText={ this.getTitle(sampling) } secondaryText={ this.getSecondaryText(sampling, keyfigures) }
						  leftAvatar={ this.getLeftAvatar() } rightAvatar={ this.getRightAvatar(nbAnalysis) }/>
			</div>
		)
	}
	getData = () => {
		return this.props.samplingSurfacePoints.map((sampling) => {
			return this.getRow(sampling)
		})
	}

	render() {
		if (this.props.samplingSurfacePoints.length) {
			return (
				<div className={ 'row no-margin' }>
					<div className={ 'row no-margin' }>
						<div className={ 'col s8 no-padding' }>
							<List>
								{ this.getData() }
							</List>
						</div>
						<div className={ 'col s4 no-padding' }>
							<SamplingSurfacePointMapPanel/>
						</div>
					</div>
				</div>
			)
		}
		return null
	}
}

SamplingSurfacePointPanel.propTypes = {
	samplingSurfacePoints: PropTypes.arrayOf(PropTypes.objectOf(DtoSamplingSurfacePoint)),
	pointKeyFigures: PropTypes.arrayOf(PropTypes.objectOf(DtoKeyFigures)),
	supports: PropTypes.arrayOf(PropTypes.objectOf(DtoSupport))
}
const mapStateToProps = store => {
	return {
		samplingSurfacePoints: store.PointReducer.samplingSurfacePoints,
		pointKeyFigures: store.PointReducer.pointKeyFigures,
		supports: store.ReferentialReducer.supports
	}
}

export default connect(mapStateToProps)(SamplingSurfacePointPanel)



// WEBPACK FOOTER //
// ./src/point/components/pointType/quality/samplingSurfacePoint/SamplingSurfacePointPanel.js